<template>
  <div v-if="show">
    <van-dialog
      class="show"
      v-model="show"
      width="90%"
      :show-confirm-button="false"
      :close-on-click-overlay="true"
    >
      <div class="productDetailForImgBox">
        <div class="productDetailForImg" ref="contentDiv">
          <div class="header">
            <div class="left">
              <div>
                <span>{{ productMsg.productName }}</span>
              </div>
              <div>
                <span>最高额度{{ productMsg.maxLine }}万</span>
                <span v-show="productMsg.minRate && productMsg.maxRate"
                  >年化利率{{ productMsg.minRate }}%-{{
                    productMsg.maxRate
                  }}%</span
                >
              </div>
            </div>
            <div class="right">
              <div id="qrCode"></div>
            </div>
          </div>
          <div class="content">
            <div
              class="item"
              v-show="productDetailMsg.productDescriptionContent"
            >
              <div class="title">
                <div><span></span></div>
                <div>产品简介</div>
              </div>
              <div
                class="item-content"
                v-html="productDetailMsg.productDescriptionContent"
              ></div>
            </div>
            <!-- 企业要求 -->
            <div
              class="item"
              v-show="productDetailMsg.companyRequirementsContent"
            >
              <div class="title">
                <div><span></span></div>
                <div>企业要求</div>
              </div>
              <div
                class="item-content"
                v-html="productDetailMsg.companyRequirementsContent"
              ></div>
            </div>
            <!-- 个人要求 -->
            <div
              class="item"
              v-show="productDetailMsg.individualRequirementsContent"
            >
              <div class="title">
                <div><span></span></div>
                <div>个人要求</div>
              </div>
              <div
                class="item-content"
                v-html="productDetailMsg.individualRequirementsContent"
              ></div>
            </div>
            <!-- 征信要求 -->
            <div
              class="item"
              v-show="productDetailMsg.creditRequirementsContent"
            >
              <div class="title">
                <div><span></span></div>
                <div>征信要求</div>
              </div>
              <div
                class="item-content"
                v-html="productDetailMsg.creditRequirementsContent"
              ></div>
            </div>
            <!-- 禁入行业 -->
            <div
              class="item"
              v-show="productDetailMsg.prohibitedIndustriesContent"
            >
              <div class="title">
                <div><span></span></div>
                <div>禁入行业</div>
              </div>
              <div
                class="item-content"
                v-html="productDetailMsg.prohibitedIndustriesContent"
              ></div>
            </div>
            <!-- 申请流程 -->
            <div
              class="item"
              v-show="productDetailMsg.applicationProcessContent"
            >
              <div class="title">
                <div><span></span></div>
                <div>申请流程</div>
              </div>
              <div
                class="item-content"
                v-html="productDetailMsg.applicationProcessContent"
              ></div>
            </div>
            <!-- 佣金说明 -->
            <div
              class="item"
              v-show="productDetailMsg.commissionDetailsContent"
            >
              <div class="title">
                <div><span></span></div>
                <div>佣金说明</div>
              </div>
              <div
                class="item-content"
                v-html="productDetailMsg.commissionDetailsContent"
              ></div>
            </div>
            <!-- 电核内容 -->
            <div class="item" v-show="productDetailMsg.coreInstructionsContent">
              <div class="title">
                <div><span></span></div>
                <div>电核内容</div>
              </div>
              <div
                class="item-content"
                v-html="productDetailMsg.coreInstructionsContent"
              ></div>
            </div>
          </div>
        </div>
        <img class="productDetailImg" :src="showImg" alt="" />
      </div>

      <div class="downloadBtn">
        <span @click="show = !show">取消</span>
        <span @click="divToImgTips">长按图片保存</span>
      </div>
    </van-dialog>
    <!-- 第一个div，用于存放图片，canvas格式，隐藏状态 -->
    <div class="erweima" style="display: none"></div>
  </div>
</template>

<script>
import Vue from "vue";
import domToImage from "dom-to-image";
import html2canvas from "html2canvas";
import QRCode from "qrcodejs2";
import { Dialog, Toast } from "vant";
Vue.use(Dialog);
Vue.use(Toast);
export default {
  data() {
    return {
      productMsg: {
      },
      productDetailMsg: {
      },
      show: false,
      showImg: "",
    };
  },

  mounted() {},

  methods: {
    // 获取页面二维码
    getQrCode() {
      let url = window.location.href;
      new QRCode(document.getElementById("qrCode"), {
        text: url,
        width: 54,
        height: 54,
        colorDark: "#333333", // 二维码颜色
        colorLight: "#ffffff", // 二维码背景色
        correctLevel: QRCode.CorrectLevel.L, // 容错率，L/M/H
      });
    },
    divToImg() {
      Toast.loading({
        duration: 0, // 持续展示 toast
        forbidClick: true,
        message: "加载中",
      });
      let that = this;
      html2canvas(that.$refs.contentDiv).then((canvas) => {
        Toast.clear();
        that.$refs.contentDiv.style.display = "none";
        that.showImg = canvas.toDataURL("image/jpeg", 1.0);
      });
    },
    divToImgTips(){
      Toast('请长按图片保存');
    }
  },
};
</script>
<style scoped>
.productDetailForImg {
  padding: 4vw;
  background-color: white;
  border: 1px solid #cccccc;
}
.productDetailForImg::-webkit-scrollbar {
  display: none;
}
.productDetailForImg img {
  width: 100%;
}
.header {
  display: flex;
  /* align-items: center; */
  padding-bottom: 4vw;
  justify-content: space-between;
  border-bottom: 1px solid #cccccc;
}
.header .left {
  display: grid;
  align-items: center;
  /* gap: 1vw; */
}
.header .left div:nth-of-type(1) {
  font-size: 5vw;
  font-weight: 600;
}
.header .left div:nth-of-type(2) {
  display: flex;
  gap: 2vw;
  font-size: 3.6vw;
}

#myCanvas {
  display: block;
  width: 14vw;
  height: 14vw;
  border-radius: 8px;
}
.content {
  /* padding: 4vw; */
}
.content .item {
  padding: 4vw 0;
  border-bottom: 1px solid #cccccc;
  word-wrap: break-word;
}
.content .item:nth-last-of-type(1) {
  border-bottom: none;
}
.downloadBtn {
  padding: 4vw;
  display: grid;
  grid-template-columns: 30vw auto;
  text-align: center;
  align-items: center;
  gap: 4vw;
}
.downloadBtn span:nth-of-type(1) {
  background-color: white;
  border: 1px solid #4988fd;
  color: #4988fd;
  padding: 3.2vw 2vw;
  border-radius: 8px;
  font-size: 4.6vw;
}
.downloadBtn span:nth-of-type(2) {
  background-color: #4988fd;
  border: 1px solid #4988fd;
  padding: 3.2vw 2vw;
  border-radius: 8px;
  font-size: 4.6vw;
  color: white;
}
.show {
  /* border-radius: 0; */
  /* background-color: rgba(0, 0, 0, 0); */
}
.productDetailImg {
  display: block;
  width: 100%;
}
.productDetailForImgBox {
  padding: 4vw 4vw 0 4vw;
  max-height: 140vw;
  overflow: auto;
}
</style>



// WEBPACK FOOTER //
// src/view/productDetail/modoule/productDetailForImg.vue